const English = {
  MAIN: '',
  CONTACT_US_TO_CHANGE_PLANS: '',
  PAYMENT_HISTORY: 'Payment history',
  EDIT_PAYMENT_METHOD: 'Edit payment method',
  PLAN: 'Plan',
  PASS: 'pass',
  PREP: 'Prep',
  REWARDS: 'My Rewards',
  ON_DEMAND_TUTORING: 'On-Demand Tutoring',
  INSTRUCTOR_AOD: 'On-Demand Tutoring',
  ON_DEMAND_TUTORING_QUESTION_DETAILS: 'View Question',
  INSTRUCTOR_ON_DEMAND_TUTORING_QUESTION_DETAILS: 'View Question',
  ON_DEMAND_TUTORING_ASK_QUESTION: 'Ask a Question',
  MY_ACCOUNT: 'My Account',
  INSTRUCTOR_MY_ACCOUNT: 'My Account',
  MAKE_A_PAYMENT: 'Make a payment',
  INSTRUCTOR_EDIT_ANSWER: 'Edit Answer',

  PROFILE: 'My Profile',
  INSTRUCTOR_PROFILE: 'My Profile',
  BILLING: 'Billing',
  HELP_CENTER: 'Help Center',
  TERMS: 'Terms & Conditions',
  HOLIDAY_CALENDAR: 'Holiday Calendar',
  CONTACT_SUPPORT: 'Contact Support',
  LOGOUT: 'Sign out',

  ACHIEVE_TEST_PREP: 'ACHIEVE TEST PREP',
  EMAIL: 'Email',
  PASSWORD: 'Password',
  REMEMBER_ME: 'Remember me on this device',
  LOGIN: 'Sign in',
  LOGIN_WITH_GOOGLE: 'Sign in with Google',
  FORGOT_PASSWORD: 'Forgot Password?',
  EMAIL_REQUIRED: 'Email is Required',
  VALID_EMAIL: 'Please provide valid Email',
  WHY_BRIDGE: 'Why Bridge?',
  PASSWORD_REQUIRED: 'Password is Required',

  RESET_PASSWORD: 'Reset Password',
  ENTER_EMAIL_ADDRESS: 'Enter your email address below to start reseting your password.',
  RESET_PASSWORD_SUCCESS:
    'If your email address has an account with us, you will receive an email within 5 minutes with instructions to reset your password. Make sure to check junk/spam folders for our email.',
  ENTER_NEW_PASSWORD: 'Enter your new password below to reset your password.',

  NEXT: 'Next',

  INSTRUCTOR_MANUAL: 'Instructor Manual',
  INSTRUCTOR_MY_TIME: 'My Time',
  INSTRUCTOR_MY_COURSES: 'My Courses',
  INSTRUCTOR_TRACK_TIME: 'Track Time',
  INSTRUCTOR_MOODLE: 'Moodle',
  INSTRUCTOR_SUPPORT_TICKET: 'Support Case',
  INSTRUCTOR_MY_COURSES_PAST: 'Past Courses',
  INSTRUCTOR_MY_COURSES_FUTURE: 'Upcoming Courses',
  INSTRUCTOR_ROSTER: 'Roster',
  INSTRUCTOR_SEND_BULK_EMAIL: 'Send Email',
  INSTRUCTOR_STUDENT_PROFILE: 'Customer Profile',
  INSTRUCTOR_STUDENT_EMAIL: 'Email',
  INSTRUCTOR_STUDENT_NOTES: 'Notes',
  INSTRUCTOR_STUDENT_COURSES: 'Courses',
  INSTRUCTOR_STUDENT_AOD: 'On-Demand Tutoring',
  INSTRUCTOR_INFORMATION_CENTER: 'Information Center',
  INSTRUCTOR_CONTACT_SUPPORT: 'Support',
  INSTRUCTOR_CONTACT_SUPPORT_HISTORY: 'History',
  INSTRUCTOR_COURSE_FEEDBACK: 'Course Feedback',

  INSTRUCTOR_SCORM_REPORTS: 'Scorm Reports',
};

export default English;

export type TLanguage = typeof English;
